import PropTypes from 'prop-types';

export default {
  name: PropTypes.string,
  avatar: PropTypes.string,
  objectId: PropTypes.string,
};
